import {
  useFormField
} from "./chunk-MJ3U6SP3.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Switch/Switch.tsx
import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
var switchStyles = twVariants({
  slots: {
    root: [
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-all",
      "data-[state=checked]:bg-brand-primary-enabled data-[state=unchecked]:bg-neutral-enabled",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-radiant-blue focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:data-[state=checked]:bg-brand-primary-disabled disabled:data-[state=unchecked]:bg-neutral-disabled"
    ],
    thumb: [
      "shadow-lg pointer-events-none block h-4 w-4 rounded-full bg-white ring-0 transition-transform",
      "data-[state=checked]:translate-x-4",
      "data-[state=unchecked]:translate-x-0",
      "data-[disabled]:bg-surface-lighter"
    ]
  }
});
var Switch = React.forwardRef(({ className, ...props }, ref) => {
  const ownProps = useFormField(props);
  const { root, thumb } = switchStyles();
  return /* @__PURE__ */ React.createElement(
    SwitchPrimitives.Root,
    {
      className: cn(root(), className),
      ...ownProps,
      ref
    },
    /* @__PURE__ */ React.createElement(SwitchPrimitives.Thumb, { className: cn(thumb()) })
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

export {
  Switch
};
//# sourceMappingURL=chunk-RN6PPSYF.js.map